export default __webpack_public_path__ + "static/icb-logo-2021-fd014975814a5b40f0c1b81209fa9361.png";